<script>
    import { ST_progressbar, ST_time } from "../stores.js";

    let pbValue = 0;
    ST_time.subscribe((value) => {
        pbValue = value;
    });
</script>

<style>
    .progressbar-fixed-area {
        position: fixed;
        display: flex;
        align-items: center;
        width: 100%;
        height: 50px;
        line-height: 50px;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
    }
    .progressbar-style {
        position: relative;
        width: 90%;
        /* height: 10px; */
        margin: 0 auto;
        /* background: #5555; */
        /* border-radius: 10px; */
    }
</style>

<div id="progressbar" class="progressbar-fixed-area">
    <progress
        class="progress is-link progressbar-style"
        value={pbValue}
        max={ST_progressbar} />
</div>
